import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7337 3.71809C11.7337 3.71817 11.7338 3.71802 11.7337 3.71809L5.25 10.2025V20.0172C5.25 20.2239 5.41821 20.3922 5.625 20.3922H9V16.2672C9 15.2319 9.83979 14.3922 10.875 14.3922H13.125C14.1602 14.3922 15 15.2319 15 16.2672V20.3922H18.375C18.5818 20.3922 18.75 20.2239 18.75 20.0172V10.2028L12.2647 3.71749C12.119 3.57179 11.8813 3.57108 11.7337 3.71809ZM20.03 9.36147L13.3253 2.65683C12.5931 1.9246 11.4067 1.92547 10.6743 2.65623L1.71964 11.6119C1.42676 11.9048 1.42679 12.3796 1.7197 12.6725C2.01261 12.9654 2.48748 12.9654 2.78036 12.6725L3.75 11.7027V20.0172C3.75 21.0524 4.58979 21.8922 5.625 21.8922H18.375C19.4102 21.8922 20.25 21.0524 20.25 20.0172V11.7028L21.2197 12.6725C21.5126 12.9654 21.9874 12.9654 22.2803 12.6725C22.5732 12.3796 22.5732 11.9047 22.2803 11.6118L20.0307 9.36219C20.0305 9.36195 20.0302 9.36171 20.03 9.36147ZM13.5 20.3922H10.5V16.2672C10.5 16.0604 10.6682 15.8922 10.875 15.8922H13.125C13.3318 15.8922 13.5 16.0604 13.5 16.2672V20.3922Z"
        fill={colorValue}
      />
    </svg>
  );
};
